import api from './api';

export const updateTransById = async payload => {
  const response = await api.put(`/trans/${payload.CODTRANS}`, payload);
  return response;
};

export const selectTransById = async payload => {
  const response = await api.get(`trans/${payload}`);
  return response.data || null;
};
